import React from 'react';
import useFlowInputComponent from '../../../../hooks/useFlowsInputComponent';
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import { NaceCode } from '../../../../types/CompanyScanTypes';
import NaceCodeInput from './NaceCodeInput';

interface Props {
  question: FlowsQuestion;
}

const NaceCodeInputComponent: React.FC<React.PropsWithChildren<Props>> = ({
  question,
}) => {
  const {
    field: { value, onBlur },
  } = useFlowInputComponent({ question, defaultValue: [] });

  const naceCodes = value as NaceCode[];

  const setNaceCodes = (naceCodes: NaceCode[]) => {
    onBlur({
      name: question.id,
      value: naceCodes.map(
        ({ code, label, level, parent_code, section_code }) => ({
          code,
          label,
          level,
          parent_code,
          section_code,
        }),
      ),
    });
  };

  return (
    <NaceCodeInput
      value={naceCodes}
      onChange={setNaceCodes}
      name={question.id}
      isDisabled={question.rules.is_disabled}
    />
  );
};

export default NaceCodeInputComponent;
